import { Fragment, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useDateLimits } from '../../../hooks'
import { Checkbox, CHECKBOX_SIZE } from '../../Checkbox'
import { DateTimePicker } from '../../DateTime'
import { FormikField, getFormikCheckboxFieldValueProps } from '../../Formik'
import { FormFieldsContainer } from '../FormFieldsContainer'

function FormFieldsDeadline({
  Container = FormFieldsContainer,
  autoFocusDate = false,
  deadlineFieldName,
  disabled,
  inputDateLabel,
  inputDatePlaceholder,
  inputTimeLabel,
  inputTimePlaceholder,
  withoutDeadlineFieldName,
  withoutDeadlineLabel,
}) {
  const { initialValues, setFieldValue, values } = useFormikContext()
  const { maxDate, minDate } = useDateLimits()

  const withoutDeadlineValue = values[withoutDeadlineFieldName]
  const deadlineInitialValue = initialValues[deadlineFieldName]

  const { t } = useTranslation()

  useEffect(() => {
    setFieldValue(
      deadlineFieldName,
      withoutDeadlineValue ? null : deadlineInitialValue
    )
  }, [deadlineFieldName, withoutDeadlineValue])

  return (
    <Container>
      <FormikField
        Component={DateTimePicker}
        dateProps={{
          autoFocus: autoFocusDate,
          label: t(inputDateLabel),
          placeholder: t(inputDatePlaceholder),
        }}
        disabled={disabled || withoutDeadlineValue}
        maxValue={maxDate}
        minValue={minDate}
        name={deadlineFieldName}
        timeProps={{
          label: t(inputTimeLabel),
          placeholder: t(inputTimePlaceholder),
        }}
      />

      {withoutDeadlineFieldName ? (
        <FormikField
          Component={Checkbox}
          Field={Fragment}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t(withoutDeadlineLabel)}
          name={withoutDeadlineFieldName}
          size={CHECKBOX_SIZE.small}
        />
      ) : null}
    </Container>
  )
}

export default FormFieldsDeadline
